'use client';
import React from 'react';
import SharedProductPrice from '@repo/ui/src/components/ProductPrice';
import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

type AlignType = 'center' | 'left' | 'right';
type VariantType =
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'h7'
  | 'bodyM'
  | 'small'
  | 'sub'
  | 'bodyL'
  | 'bodyXL';

interface ProductPriceProps {
  product: MeaterProduct;
  variantId?: string;
  flipOrder?: boolean;
  className?: string;
  strikethroughClassName?: string;
  align?: AlignType;
  color?: 'white';
  variant?: VariantType | false;
  component?: any;
  gutterBottom?: boolean;
  outOfStock?: boolean;
  hideDiscount?: boolean;
}

const ProductPrice = ({ product, variantId, ...props }: ProductPriceProps) => {
  const activeVariant = variantId ? product.variants.find((v) => v.id === variantId) : undefined;

  const price = activeVariant?.price ?? product.price;
  const originalPrice = activeVariant ? activeVariant.compareAtPrice : product.originalPrice;
  const discount = activeVariant
    ? originalPrice && originalPrice > price
      ? Math.round(((originalPrice - price) / originalPrice) * 100)
      : undefined
    : product.discount;

  return <SharedProductPrice {...props} product={{ price, originalPrice, discount }} vip={false} />;
};

export default ProductPrice;
